import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TramiteService, DatosTramite, BusquedaTramite, DocumentoPDF } from '../services/tramite.service';

@Component({
  selector: 'app-contenedor',
  templateUrl: './contenedor.component.html',
  styleUrls: ['./contenedor.component.css']
})

export class ContenedorComponent implements OnInit {

  // declaraciòn de variables
  @Input() FormBusquedaTramite: FormGroup;
  TiposDeTramites: any;
  MensajeBusqueda: boolean;
  busquedaTramite: BusquedaTramite;
  datosTramite: DatosTramite;
  MostrarLoader = false;

  // Método que indica si se resolvio el captcha.
  public resolved(captchaResponse: string) {
    // console.log(`Código Captcha resuelto ${captchaResponse}:`);
  }

  // Funcion que controla los cambios del formulario de consulta
  ControlDeCambios() {
    // Obtiene los controles del formulario
    const CambioCodigoTramite = this.FormBusquedaTramite.get('CodigoTramite');
    const CambioTipoTramite = this.FormBusquedaTramite.get('TipoTramite');
    // Captura si hay cambios en el objeto codigo de tramite
    CambioCodigoTramite.valueChanges.forEach(
      (value: string) => {
        this.MensajeBusqueda = false;
        if (this.datosTramite) {
          this.datosTramite = null;
        }
      }
    );
    // caputra si hay cambios en el objeto codigo de tramite
    CambioTipoTramite.valueChanges.forEach(
      (value: string) => {
        this.MensajeBusqueda = false;
        if (this.datosTramite) {
          this.datosTramite = null;
        }
      }
    );
  }

  // mètodo de consulta de tramite
  ConsultaTramite() {
    this.MostrarLoader = true;
    // carga los parametros
    this.busquedaTramite = {
      CodigoTramite: this.FormBusquedaTramite.value.CodigoTramite,
      TipoTramite: this.FormBusquedaTramite.value.TipoTramite,
      ValidaEstadoSolicitud: true
    };
    // consulta al servicio para obtener datos dle trmaite
    this.tramiteService.obtenerTramite(this.busquedaTramite).subscribe(
      datosTramite => {
        this.MostrarLoader = false;
        // Valida si existe un resultado.
        if (datosTramite) {
          // Carga los datos al modelo.
          this.datosTramite = datosTramite;
        } else {
          // muestra el mensaje
          this.MensajeBusqueda = true;
        }
      }
    );
  }
  LimpiarDatos() {
    this.FormBusquedaTramite.reset({
      CodigoTramite: null
    });
    this.FormBusquedaTramite.controls.TipoTramite.setValue('');
    this.MostrarLoader = false;
  }
  // metodo para obtener el documento
  ObtenerArchivo() {
    // habilita el loader
    this.MostrarLoader = true;
    // carga los parametros
    this.busquedaTramite.CodigoTramite = this.FormBusquedaTramite.value.CodigoTramite;
    this.busquedaTramite.TipoTramite = this.FormBusquedaTramite.value.TipoTramite;
    this.tramiteService.obtenerDocumento(this.busquedaTramite).subscribe(
      documentoPDF => {
        // decodifica la base 64.
        const vDecodificado = atob(String(documentoPDF));
        // Obtiene el tamaño.
        const vTamano = vDecodificado.length;
        // representan un array de enteros sin signo de 8 bits.
        const array = new Uint8Array(new ArrayBuffer(vTamano));
        // Recorre todo el array.
        for (let i = 0; i < vTamano; i++) {
          // Devuelve un número indicando el valor Unicode del carácter.
          array[i] = vDecodificado.charCodeAt(i);
        }
        // Representa un objeto tipo fichero de datos planos inmutables.
        const blob = new Blob([array], { type: 'application/pdf' });
        // Nuevo objeto URL representa al objeto File especificado o al objeto Blob.
        const url = window.URL.createObjectURL(blob);
        // Abre el nuevo objeto.
        window.open(url);
        // Desabilita el loader
        this.MostrarLoader = false;
      }
    );
  }

  constructor(public tramiteService: TramiteService, private formBuilder: FormBuilder) {
    // Carga la información de inicio
    this.TiposDeTramites = [
      { value: 'par_estado_legalizacion', text: 'Legalización' },
      { value: 'par_estado_saneamiento', text: 'Saneamiento' }
    ];
    // Instancia las validaciones
    this.FormBusquedaTramite = formBuilder.group({
      TipoTramite: ['', Validators.required],
      CodigoTramite: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*'), Validators.minLength(8)]],
      Captcha: [null, Validators.required]
    });
    // Inicia la función de control de cambios
    this.ControlDeCambios();
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/contenedor/contenedor.component.ts